const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanfossLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 739.6 283.5",
    style: {
      enableBackground: "new 0 0 739.6 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#E30613;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:url(#SVGID_1_);}\r\n\t.st4{fill:url(#SVGID_2_);}\r\n"), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 739.6,
    height: 283.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.2,
    y: 56.7,
    className: "st1",
    width: 389.7,
    height: 170.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.5,130h-8.2v7.6h9.1v2.3H56.6v-21.1H68v2.3h-8.7v6.7h8.2V130z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.6,139.9v-21.1h3l6.7,10.7c1.5,2.5,2.8,4.7,3.7,6.9l0.1,0c-0.3-2.8-0.3-5.4-0.3-8.6v-8.9h2.6v21.1h-2.8 L80,129.2c-1.5-2.4-2.9-4.8-3.9-7l-0.1,0c0.2,2.7,0.2,5.2,0.2,8.7v9H73.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.8,139c-1.2,0.5-3.7,1.1-6.5,1.1c-3.2,0-5.8-0.8-7.9-2.8c-1.8-1.8-2.9-4.6-2.9-7.9 c0-6.3,4.3-10.9,11.4-10.9c2.4,0,4.4,0.6,5.3,1l-0.7,2.2c-1.1-0.5-2.5-0.9-4.7-0.9c-5.1,0-8.5,3.2-8.5,8.5c0,5.4,3.2,8.5,8.1,8.5 c1.8,0,3-0.2,3.6-0.6V131h-4.3v-2.2h7V139z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.2,118.8v21.1h-2.7v-21.1H120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126.5,139.9v-21.1h3l6.7,10.7c1.5,2.5,2.8,4.7,3.7,6.9l0.1,0c-0.3-2.8-0.3-5.4-0.3-8.6v-8.9h2.6v21.1h-2.7 l-6.7-10.7c-1.5-2.4-2.9-4.8-3.9-7l-0.1,0c0.1,2.7,0.2,5.2,0.2,8.7v9H126.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159.5,130h-8.2v7.6h9.1v2.3h-11.9v-21.1h11.4v2.3h-8.7v6.7h8.2V130z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M176.5,130h-8.2v7.6h9.2v2.3h-11.9v-21.1H177v2.3h-8.7v6.7h8.2V130z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M182.6,119.1c1.4-0.3,3.4-0.5,5.2-0.5c2.9,0,4.8,0.6,6.1,1.8c1,0.9,1.6,2.3,1.6,4c0,2.7-1.8,4.6-4,5.3v0.1 c1.6,0.6,2.6,2.1,3.1,4.2c0.7,2.9,1.2,5,1.6,5.8h-2.8c-0.3-0.6-0.8-2.4-1.4-5c-0.6-2.9-1.8-4-4.3-4.1h-2.6v9.1h-2.7V119.1z  M185.3,128.7h2.8c2.9,0,4.7-1.6,4.7-4c0-2.7-2-3.9-4.8-3.9c-1.3,0-2.2,0.1-2.7,0.3V128.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M203.7,118.8v21.1h-2.8v-21.1H203.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M210,139.9v-21.1h3l6.7,10.7c1.5,2.5,2.8,4.7,3.8,6.9l0.1,0c-0.3-2.8-0.3-5.4-0.3-8.6v-8.9h2.6v21.1H223 l-6.7-10.7c-1.5-2.4-2.9-4.8-3.9-7l-0.1,0c0.1,2.7,0.2,5.2,0.2,8.7v9H210z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M248.2,139c-1.2,0.5-3.7,1.1-6.5,1.1c-3.2,0-5.8-0.8-7.9-2.8c-1.8-1.8-2.9-4.6-2.9-7.9 c0-6.3,4.3-10.9,11.4-10.9c2.4,0,4.4,0.6,5.3,1l-0.7,2.2c-1.1-0.5-2.5-0.9-4.7-0.9c-5.1,0-8.5,3.2-8.5,8.5c0,5.4,3.2,8.5,8.1,8.5 c1.8,0,3-0.2,3.6-0.6V131h-4.3v-2.2h6.9V139z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.4,151.5h-5.7v-4h16.2v4h-5.8v17.1h-4.7V151.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.8,168.9c-6.2,0-9.9-4.7-9.9-10.7c0-6.3,4.1-11,10.2-11c6.5,0,10,4.8,10,10.7 C95.2,164.8,91,168.9,84.8,168.9L84.8,168.9z M85.1,165.1c3.2,0,5.1-3,5.1-7.2c0-3.8-1.8-7-5.1-7c-3.3,0-5.1,3.2-5.1,7.1 C79.9,162,81.9,165.1,85.1,165.1L85.1,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M118.5,160.5c-0.1-2.5-0.2-5.6-0.2-8.7h-0.1c-0.7,2.7-1.5,5.7-2.4,8.2l-2.6,8.2h-3.7l-2.3-8.1 c-0.7-2.5-1.4-5.5-1.9-8.3h-0.1c-0.1,2.8-0.2,6.1-0.3,8.7l-0.4,8h-4.4l1.3-21.1h6.3l2.1,7.1c0.7,2.4,1.3,5,1.8,7.5h0.1 c0.6-2.4,1.3-5.2,2-7.6l2.2-7h6.3l1.1,21.1h-4.6L118.5,160.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M138.5,168.9c-6.2,0-9.9-4.7-9.9-10.7c0-6.3,4.1-11,10.3-11c6.5,0,10,4.8,10,10.7 C148.9,164.8,144.7,168.9,138.5,168.9L138.5,168.9z M138.8,165.1c3.2,0,5.1-3,5.1-7.2c0-3.8-1.8-7-5.1-7c-3.3,0-5.1,3.2-5.1,7.1 C133.6,162,135.5,165.1,138.8,165.1L138.8,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M154.6,147.8c1.5-0.3,3.8-0.5,6.3-0.5c3.1,0,5.3,0.5,6.8,1.7c1.3,1,2,2.5,2,4.4c0,2.7-1.9,4.5-3.7,5.2v0.1 c1.5,0.6,2.3,2,2.8,3.9c0.7,2.4,1.3,5.1,1.7,6h-4.9c-0.3-0.6-0.8-2.3-1.4-4.9c-0.6-2.7-1.5-3.4-3.5-3.4h-1.4v8.3h-4.7V147.8z  M159.4,156.8h1.9c2.4,0,3.8-1.2,3.8-3c0-1.9-1.3-2.9-3.5-2.9c-1.1,0-1.8,0.1-2.2,0.2V156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.2,147.8c1.5-0.3,3.8-0.5,6.3-0.5c3.1,0,5.3,0.5,6.8,1.7c1.3,1,2,2.5,2,4.4c0,2.7-1.9,4.5-3.7,5.2v0.1 c1.5,0.6,2.3,2,2.8,3.9c0.7,2.4,1.3,5.1,1.7,6h-4.9c-0.3-0.6-0.9-2.3-1.5-4.9c-0.6-2.7-1.5-3.4-3.5-3.4h-1.4v8.3h-4.7V147.8z  M181.9,156.8h1.9c2.4,0,3.8-1.2,3.8-3c0-1.9-1.3-2.9-3.5-2.9c-1.2,0-1.8,0.1-2.2,0.2V156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M207.5,168.9c-6.2,0-9.9-4.7-9.9-10.7c0-6.3,4.1-11,10.3-11c6.5,0,10,4.8,10,10.7 C217.8,164.8,213.7,168.9,207.5,168.9L207.5,168.9z M207.7,165.1c3.2,0,5.1-3,5.1-7.2c0-3.8-1.8-7-5.1-7c-3.3,0-5.1,3.2-5.1,7.1 C202.6,162,204.5,165.1,207.7,165.1L207.7,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M226.8,168.6l-5-21.1h5.1l1.6,8.7c0.5,2.5,0.9,5.3,1.3,7.4h0.1c0.3-2.3,0.9-4.9,1.4-7.5l1.8-8.6h5.1l1.7,8.9 c0.5,2.5,0.8,4.7,1.1,7.1h0.1c0.3-2.4,0.8-4.8,1.2-7.4l1.7-8.6h4.9l-5.4,21.1h-5.2l-1.8-9.1c-0.4-2.1-0.7-4.1-1-6.5h-0.1 c-0.4,2.4-0.7,4.4-1.2,6.5l-2,9.1H226.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M341.9,110.1c24.3-9.1,51.8-15,79.9-10.9l2.9-5.3c5.8-0.9,11.7-1.7,17.5-2.3l-7.8,11.9 c7.6,3.3,13.9,11.3,14.6,19.7c0,11.4-5.1,20.9-10.9,29.7l8.5-1c5.7-9.3,21.7-20.5,28.3-12l2.3-3.2c0,0,10.5-1.6,10.7-1.6 c-9.3,17.3-14.3,22-13.1,23.6c1.4,1.9,18.4-13.2,24.8-25.5l10.1-1.1l-5.7,10.1c10.2-8.4,13.9-13.8,19.6-11.4 c7.9,3.3-9.4,21.7-7.5,22.9c1.6,1,15.5-9.2,22.2-19.5l-9.5,1.5l3.3-6.2l9.4-1.2c10.2-18.8,37-54.7,45.2-49.4 c7.6,4.9-10.7,28.7-34.7,45.9l-1.5,2.7l20.8-2.3c0.4,0.2,0.6,0.9,0.1,1.3c-6.7,5.7-19.9,19.6-13,23.9c6.1,2.2,15.6-11.9,16.5-14.8 c-5.4-1.7-1.1-16.8,6.6-14.8c5.2,1.8,1.3,9.2,0,12.1c9.9-1.2,18.8-11.3,18.8-11.3c-0.1-8,5-16.6,10.9-14.5c3.8,2,0.7,7.7-5.6,14.4 c-0.8,0.8-0.4,3.9-0.5,7.6c6.7-2.3,14.3-5.5,20.6-8.6c0.1-7.7,3.9-17,10.4-15.1c4.7,1.4,0,10.9-5.9,15.7c-0.1,10.3,1.6,17.1-1,22.5 c-3,6.2-13.4,11.4-19.6,7.8c-6.4-3.7-0.7-12,3.2-15.1c3.5-2.9,12.4-7,12.4-7s0.5-3.5,0.3-5.2c-3.5,2.1-20.2,8.3-20.2,8.3 c-0.7,6.1-0.6,8.6-3.5,14.2c-3.6,6.9-15.5,9.7-19.5,5.8c-2.8-2.7-2-9.2,3.8-13.8c4.3-3.5,13.5-7.3,13.5-7.3s0.8-3.5,0.5-4.9 c-5.9,5.1-12.6,10.2-21.2,10.4l0,0c-5.2,10.4-19.1,24.8-29,18.3c-9.6-6.2,5.8-22.6,7.4-23.8c-3.2,0.2-9.6,1.6-9.6,1.6l-16.9,31.3 l0.2-0.1c0,0,57.7-6.6,110.1-6.7l-6.3,5.9c3,2.1,6.1,4.2,9.3,6c0,0-54.6-2.4-117.5,2.8l-9.2,17.1l-11.4,0.8l9.9-17.1 c0,0-28.6,0.9-91.4,9.4c0.7-1.3,0.9-1.6,1.9-3.3C482.2,167.8,520,165,520,165s8.8-15.1,8.4-14.8c-5.5,4.6-17.7,14.4-22.8,9.6 c-3.7-4.6,9.2-19.3,7.7-20.5c-1.2-1-16.5,14.7-22,23.3c-3.1,0.2-8.9,0.9-8.9,0.9l4.4-8.6c-5,3.9-10.3,8.1-15.9,10.3 c-1.6,0.6-5.2,0.8-6.7-3.4c0,0-11.3,10.2-18.9,6.3c-4.1-2.1-2.2-9.8-1.5-11.5l-9,1c-39,45.2-89.9,50.3-96,40.4 c-6.5-10.6,16.6-24.8,48.2-34.8c0,0,28.1-50.6,27.6-51c-38.8-5.9-86.8,23.9-86.8,23.9L341.9,110.1z M356.7,191.6 c4.6,5.8,42.7-0.3,68.5-32.3c-17.8,2.8-28.4,6.6-32.3,8c-8.4,13.7-11.9,18.7-15.1,18.2c-3.9-0.5,2.3-7.9,5.6-15 C369.4,175.1,352.4,186.2,356.7,191.6z M397.8,160c10-2.7,25.6-5.2,30.9-5.8c4.5-7.3,19.1-31.6-1.8-39.2L397.8,160z M458.2,149.8 c-3,4-6.2,10.7-3.8,12.6c2.5,1.9,9.3-4,11.6-6.9c3.9-5.1,7.1-12.1,4.7-13.4C466.9,140.1,460.3,147,458.2,149.8z M556.4,116.3 c7.6-4.7,27-24,22.2-28.5C573.6,85.6,560.3,107.1,556.4,116.3z M591,139.2c-3.2,2.3-4.8,5.2-3.2,6.5c1.5,1.2,5.5-1.1,7.2-3.6 c2.8-3.8,3.4-7.1,3.4-7.1S595.9,135.6,591,139.2z M616.2,137.9c-1.1,1-5.2,4.7-3.4,6.5c1.5,1.6,6-1.1,7.8-3.2 c2.4-2.9,3.6-7.5,3.6-7.5S619.4,135.1,616.2,137.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -2665.5117,
    cy: 26.0221,
    r: 537.4837,
    fx: -2728.3982,
    fy: 95.4872,
    gradientTransform: "matrix(-6.887427e-02 0.8294 -2.922520e-02 -4.132971e-03 501.3384 2260.2905)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#111111"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    style: {
      stopColor: "#444444",
      stopOpacity: 0.778
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    style: {
      stopColor: "#555555",
      stopOpacity: 0.5697
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999999",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 682.9,
    y: 56.7,
    className: "st3",
    width: 31.1,
    height: 170.1
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: -2955.5637,
    cy: 26.0221,
    r: 537.4837,
    fx: -3018.4502,
    fy: 95.4872,
    gradientTransform: "matrix(6.887427e-02 0.8294 2.922520e-02 -4.132971e-03 494.7734 2500.8723)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#111111"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    style: {
      stopColor: "#444444",
      stopOpacity: 0.778
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    style: {
      stopColor: "#555555",
      stopOpacity: 0.5697
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999999",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 262.2,
    y: 56.7,
    className: "st4",
    width: 31.1,
    height: 170.1
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanfossLogo);
export default __webpack_public_path__ + "static/media/danfossLogo.f3d5d368118603a56c8094851a448435.svg";
export { ForwardRef as ReactComponent };